import { ActionTree } from 'vuex';

import { IRevenueState } from '@/store/modules/revenue/types';
import { IRootState } from '@/store/types';

export const actions: ActionTree<IRevenueState, IRootState> = {
};
